export default __webpack_public_path__ + "static/media/table_view_icon_disabled.ff4857c5.svg";